























    import AbpBase from '../../lib/abpbase'
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import {getLodop} from '../../lib/lodop.js'

	@Component
    export default class stockBills extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop({type:Object,default:false}) data:object;
        @Prop({type:String,default:''}) title:string;

        datas:any = this.data
        LODOP:any = ''
        mounted() {
            console.log(this.datas)
            this.$nextTick(() => {
                // if(PRINT_SWITCH){
                //     this.printPdf()
                // }
            })
        }
        printPdf(){
            try {
                let  LODOP = getLodop();
                //判断打印是否初始化完成
                if(LODOP){
                    //设定打印纸张为固定纸张或自适应内容高，并设定相关大小值或纸张名及打印方向
                    //初始化运行环境，清理异常打印遗留的系统资源，设定打印任务名
                    //设置打印项的输出风格，成功执行该函数，此后再增加的打印项按此风格输出
                    let strBodyStyle=
                    `<style>
                        *{font-size: 16px}
                        h1{font-size: 30px;text-align: center;padding:5px 0;}
                        h2{font-size: 24px;text-align: center;padding:5px 0;}
                        th,td{padding:8px;text-align:left;}
                        table{border:1px solid #000;}
                        td,th{border-right:1px solid #000;border-bottom:1px solid #000;}
                        tr:last-child td{border-bottom:none;}
                        td:last-child,th:last-child{border-right:none;}
                        tr:last-child{border-bottom:none;}
                    </style>`;
		            let strFormHtml=strBodyStyle+"<body>"+(this.$refs.print as any).innerHTML+"</body>";
                    LODOP.SET_PRINT_STYLE("FontSize", 14);
                    LODOP.SET_PRINT_STYLE("Bold", 1);
                    LODOP.ADD_PRINT_TEXT(0, 0, 0, 0, "打印页面部分内容");
                    //增加超文本打印项，设定该打印项在纸张内的位置和区域大小，实现超文本控制打印。
                    LODOP.ADD_PRINT_HTM(20, 0, 0, 1670,strFormHtml);
                    LODOP.SET_PRINT_PAGESIZE(2, 0, 0, "A4"); //规定纸张大小；使用A4纸。
                    LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1);//横向时的正向显示
                    LODOP.PREVIEW();
                }
                //预览中|打印中，返回回调函数
                this.$emit('on-finish')
            } catch(err) {
                console.log(err)
            }
        }
        //获取当日时间
        get getdate(){
            //当日时间
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month:any = date.getMonth() + 1;
            let strDate:any = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            return  year + seperator1 + month + seperator1 + strDate;
        }
        //登陆人
        get userName(){
            return this.$store.state.session.user?this.$store.state.session.user.name:''
        }
        //医院名称
        get hospitalName(){
            return this.$store.state.hospitalInfo.hospitalName?this.$store.state.hospitalInfo.hospitalName:''
        }
	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/print/stockBills.vue